<template>
  <div class="flex items-center justify-center gap-1 px-2 py-1 rounded-lg w-max" :style="{background: color(title, 0.3)}">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="w-4 h-4">
      <rect width="256" height="256" fill="none" />
      <circle
        cx="128"
        cy="76"
        r="36"
        :fill="userPreference.indexOf(title) === 0 ? color(title, 1) : 'none'"
        :stroke="color(title, 1)"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <circle
        cx="188"
        cy="172"
        r="36"
        :fill="userPreference.indexOf(title) === 1 ? color(title, 1) : 'none'"
        :stroke="color(title, 1)"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <circle
        cx="68"
        cy="172"
        r="36"
        :fill="userPreference.indexOf(title) === 2 ? color(title, 1) : 'none'"
        :stroke="color(title, 1)"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </svg>
    <t-text size="sm" color="unset" class="font-semibold" :style="{color: color(title, 1)}">{{ title }}</t-text>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 't-user-preference',
    props: {
      title: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapGetters(['theme']),
      ...mapGetters('user', ['userPreference'])
    },
    methods: {
      color(string, alpha) {
        const colors = []
        if (this.theme === 'light')
          colors.push(`rgba(24, 73, 169, ${alpha})`, `rgba(9, 92, 55, ${alpha}`, `rgba(238, 161, 60, ${alpha})`)
        else colors.push(`rgba(123, 164, 233, ${alpha})`, `rgba(19, 194, 116, ${alpha}`, `rgba(213, 147, 76, ${alpha})`)

        return colors[this.userPreference.indexOf(string)]
      }
    }
  }
</script>
